import $ from 'jquery'
import 'slick-carousel'
class InitRelatedNews {
    constructor() {
        this.slider = document.querySelector('.single-blog-press-template #CarouselWeDo');
    }

    slickOption(){
        return {
            slidesToShow: 2,
            slidesToScroll: 1,
            dots: true,
            infinite: false,
            focusOnSelect: true,
            variableWidth: true,
            nextArrow:
                '<button type="button" class="slick-next ecf-slider-arrow ecf-slider-arrow-slide-next">Next</button>',
            prevArrow:
                '<button type="button" class="slick-prev ecf-slider-arrow ecf-slider-arrow-slide-prev">Previous</button>',
            responsive: [
                {
                    breakpoint: 1025,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        variableWidth: false,
                    },
                },
                {
                    breakpoint: 990,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        arrows:false
                    },
                },
                {
                    breakpoint: 763,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        centerMode: true,
                        centerPadding: "13px",
                        arrows:false
                    },
                },
                {
                    breakpoint: 321,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        variableWidth: false,
                        centerMode: true,
                        centerPadding: "13px",
                        arrows:false
                    },
                },
            ],
        }
    }

    init(){
        let slider = this.slider;
        let options = this.slickOption();
        if(slider){
            let $slider = $(slider);
            $slider.slick(options)
            let slickArrow = $(
                ".slick-arrow"
            );
            let slickList = $('.slick-list');
            slickArrow.hover(()=>{
                slickList.toggleClass('hover');
            })
        }
    }

}
 export  default InitRelatedNews